export default __webpack_public_path__ + "static/media/1835.bc917265.png";